import { makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Layout from '../../invoices/common/Layout';
import PaymentTable from '../PaymentTable/PaymentTable';
import { CommonConfig } from '../../../config/common-config';
import LoaderPopUp from '../../../components/loaderpopup/loader'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
}));

function CorporatePaymmentHistory(props, row) {
    const [selectedImc, setselectedImc] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [AllImcs, setAllImcs] = useState([]);
    const [rows, setTotalReactPackages] = useState([]);
    const [handleGeneratedReceipt, setHandleGeneratedReceipt] = useState([]);
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [allCorps, setAllCorps] = useState([]);
    const [selectedCorp, setselectedCorp] = useState([]);

    // For Implementating JWT-Token
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const headcells = [
        { id: 'clientName', label: 'Name' },
        {
            id: 'invoiceId',
            label: 'Invoice Number',
            isConcat: 'true',
            concatElem: ['invoiceNumber'],
        },
        {
            id: 'invoiceId',
            label: 'Invoice Date',
            isConcat: 'true',
            concatElem: ['invoiceDate'],
            date: 'true',
        },
        {
            id: 'invoiceId',
            label: 'Invoice amount',
            isConcat: 'true',
            concatElem: ['total'],
        },
        {
            id: 'razorpayPaymentId',
            label: 'Reference Number',
        },
        {
            id: 'paymentDate',
            label: 'Amount Received on',
            date: 'true',
        },
    ];

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => setAllImcs(response.data.content))
            .catch((error) => { });

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/payment-history-clients/${selectedImc}/Corporate/${selectedCorp}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setTotalReactPackages(response.data.content);
            })
            .catch((error) => { });
    }, [handleGeneratedReceipt, userToken]);

    const allImcsOptions = (imcData) => {
        const OptionList = imcData.map((data) => <option value={data.dbName}>{data.dbName}</option>);
        return OptionList;
    };

    const allCorpOptions = (corpData) => {
        const OptionList = corpData.map((corp) => <option value={corp.corpclientId}>{corp.corpClientName}</option>);
        return OptionList;
    };

    const handleGenerateReceipt = (data) => {
        setShowBtnLoader(true);

        if (data.paymentId) {
            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/generate-receipt/${selectedImc}/${data.paymentId}`, '', {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    setHandleGeneratedReceipt(response.data.content);
                    setShowBtnLoader(false);
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (errResult.data) {
                    }
                });
        }
    };

    // search Query
    const handleSearchQuery = (searchData) => {
        setSearchQuery(searchData);
    };

    const setImc = (e) => {
        setselectedImc(e.target.value);
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/ultimate_corp_client/${e.target.value}?page=0&size=1000`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setAllCorps(response.data.content);
            })
            .catch((error) => {
                const errResult = error.response;
                if (errResult.data) {
                }
            });
    };

    const setCorp = (e) => {
        setselectedCorp(e.target.value);
        axios
            .get(`${CommonConfig.dev.baseUrl}/auth/intClient-colleague/${selectedImc}/${e.target.value}?page=0&size=1000`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setTotalReactPackages(response.data.content);
            })
            .catch((error) => { });
    };

    // Filtered Row based on search
    // const filteredRow = searchQuery
    //     ? rows.filter((rowData) => {
    //         const query = searchQuery.toLowerCase().trim();
    //         return headcells
    //             .map((col) => col.id)
    //             .some((key) => {
    //                 return rowData[key].toString().toLowerCase().includes(query);
    //             });
    //     })
    //     : rows;

    // Search through nested objects
    const filteredRow = searchQuery
        ? rows.filter((searchRow) => {
            const query = searchQuery.toLowerCase().trim();
            //   ////console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
            return headcells
                .map((col) => col)
                .some((key) => {
                    //   ////console.log(key, 'from inside some');

                    if (key.isConcat && searchRow[key.id]) {
                        //   ////console.log("Search Row",searchRow);
                        const subdata = searchRow[key.id];
                        //   ////console.log(subdata,"subData");
                        const mergedData = key.concatElem.map((concatdata) => {
                            //   ////console.log(concatdata,"concatData");
                            return concatdata.split('.').reduce((acc, item) => {
                                //console.log(acc ,item,"Acc item from reduce")
                                if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                    if (typeof acc[item] !== 'object') {
                                        return acc[item].toString().toLowerCase().includes(query);
                                    }
                                    return acc[item];
                                }
                                return false;
                            }, subdata);
                        });
                        //console.log(mergedData,"mergeData");

                        return mergedData[0];
                    }
                    return searchRow[key.id].toString().toLowerCase().includes(query);
                });
        })
        : rows;

    const classes = useStyles();
    return (
        <>
            {(showBtnLoader && (
                <LoaderPopUp showLoader={showBtnLoader} />
                // <div style={{ position: 'relative', top: 300, left: 700 }}>
                //     <span style={{ position: 'absolute', top: 20 }}>Loading......</span>
                //     <CircularProgress style={{ color: '#F8951B' }} size={20} />
                // </div>
            )) || (
                    <div className={classes.root}>
                        <div className="itec-textboxes">
                            Select IMC
                        <select className="intclientName intSelect" name="intclientName" onChange={setImc} value={selectedImc}>
                                <option value="" selected disabled hidden>
                                    Select IMC
                            </option>
                                {allImcsOptions(AllImcs)}
                            </select>
                            <select className="itecInputBox intSelect" name="corpClientId" onChange={setCorp} value={selectedCorp}>
                                <option value="" selected disabled hidden>
                                    Select Corp
                            </option>
                                {allCorpOptions(allCorps)}
                            </select>
                        </div>
                        <Layout title="Payment History" searchQuery={searchQuery} onChange={handleSearchQuery} className={classes} />
                        {filteredRow.length === 0 && <span style={{ fontSize: '14px', fontWeight: '500' }}>No records found to display!</span>}
                        <PaymentTable
                            headcells={headcells}
                            rows={filteredRow}
                            pageName="admin"
                            handleGenerateReceipt={handleGenerateReceipt}
                            action
                            attachment
                        />
                    </div>
                )}
        </>
    );
}

export default CorporatePaymmentHistory;
